/**
 * @shelf-version: 1.1.0
 */

import ScrollTo from './scroll-to'

export default ScrollTo
